module.exports = __webpack_public_path__ + "static/media/AU Impact Cards.51c60d43.csv";